
import React from 'react';
import { Facebook, Instagram, Mail, MapPin, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-slate-900 border-t border-amber-500/20">
      <div className="container mx-auto px-4 py-12">
        <div className="flex flex-col md:flex-row gap-8 items-start md:justify-between">
          {/* Kontaktinfo */}
          <div className="w-full md:w-[37.5%]">
            <h3 className="text-lg font-semibold text-amber-400 mb-4">Kontakt</h3>
            <div className="space-y-3 text-slate-300">
              <div className="flex items-center space-x-3">
                <MapPin size={18} className="text-amber-400" />
                <span>Universitätssportzentrum Wien<br />Auf der Schmelz 6, 1150 Wien</span>
              </div>
              <div className="flex items-center space-x-3">
                <Phone size={18} className="text-amber-400" />
                <span>+43 69910866515</span>
              </div>
              <div className="flex items-center space-x-3">
                <Mail size={18} className="text-amber-400" />
                <span>info@asc-fechten.at</span>
              </div>
            </div>
          </div>

          {/* Trainingszeiten */}
          <div className="w-full md:w-[37.5%]">
            <h3 className="text-lg font-semibold text-amber-400 mb-4">Trainingszeiten</h3>
            <div className="space-y-2 text-slate-300">
                    <p>Montag: 16:15 - 20:30</p>
                    <p>Dienstag: 20:00-21:30</p>
                    <p>Mittwoch: 16:00 - 20:00</p>
                    <p>Donnerstag: 17:30 - 20:30</p>
                    <p>Freitag: 16:00 - 19:00</p>
            </div>
          </div>

          {/* Social Media */}
          <div className="w-full md:w-[25%]">
            <h3 className="text-lg font-semibold text-amber-400 mb-4">Folge uns</h3>
            <div className="flex space-x-4">
              <a 
                href="https://www.facebook.com/people/ASC-Fechten/100057153112929/" 
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-300 hover:text-amber-400 transition-colors"
                aria-label="ASC Fechten Wien auf Facebook besuchen"
              >
                <Facebook size={24} />
              </a>
              <a 
                href="https://www.instagram.com/asc_fechten/" 
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-300 hover:text-amber-400 transition-colors"
                aria-label="ASC Fechten Wien auf Instagram besuchen"
              >
                <Instagram size={24} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-amber-500/20 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-slate-400">
              &copy; 2024 Akademischer Sportclub Fechten Wien. Alle Rechte vorbehalten.
            </p>
            
            <a 
              href="https://wgtdigital.at/" 
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-2 text-slate-400 hover:text-amber-400 transition-colors"
            >
              <picture>
                <img 
                  src="/lovable-uploads/a1ae5037-c70e-44d5-afb4-d65e1f8f1341.png" 
                  alt="WGT Digital Logo" 
                  className="h-6 w-auto object-contain"
                  width="61"
                  height="24"
                  loading="lazy"
                  sizes="61px"
                  style={{ maxWidth: '61px', height: '24px', objectFit: 'contain' }}
                />
              </picture>
              <span className="text-sm">Webdesign von Wgtdigital</span>
            </a>
            
            <div className="flex space-x-6 text-sm">
              <Link to="/impressum" className="text-slate-400 hover:text-amber-400 transition-colors">
                Impressum
              </Link>
              <Link to="/datenschutz" className="text-slate-400 hover:text-amber-400 transition-colors">
                Datenschutzerklärung
              </Link>
              <Link to="/agb" className="text-slate-400 hover:text-amber-400 transition-colors">
                AGB
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
